var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "drag-pipeline-row",
      class: [_vm.checked && "selected"],
      attrs: { id: _vm.item._id },
    },
    [
      (_vm.item.attachments || []).length > 0 &&
      (_vm.item.coverPhoto ||
        _vm.item.attachments[0].ext === "png" ||
        _vm.item.attachments[0].ext === "jpg" ||
        _vm.item.attachments[0].ext === "jpeg")
        ? _c(
            "div",
            { attrs: { id: "image-preview" }, on: { click: _vm.view } },
            [
              _vm.item.coverPhoto
                ? _c("img", {
                    attrs: { src: _vm.getCoverPhotoUrl(), alt: "attachment" },
                  })
                : _c("img", {
                    attrs: { src: _vm.getAttachmentUrl(), alt: "attachment" },
                  }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "drag-pipeline-row-card",
          attrs: { type: _vm.pipeline.type },
        },
        [
          _c(
            "div",
            { staticClass: "row-check" },
            [
              _c("a-checkbox", {
                staticClass: "kanban-checkbox",
                attrs: { checked: _vm.checked },
                on: {
                  change: function (e) {
                    return _vm.check(e)
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "content", on: { click: _vm.view } }, [
            (_vm.item.relations || []).some(function (relation) {
              return relation.type === "visitor"
            })
              ? _c(
                  "div",
                  { staticClass: "visitor-task" },
                  [
                    _c("PlatformIconViewer", {
                      staticStyle: {
                        width: "15px",
                        height: "15px",
                        "align-items": "normal",
                      },
                      attrs: { platform: _vm.getVisitorPlatform() },
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.getVisitorFullname()))]),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "task-head" },
              [
                _c("div", { staticClass: "task-title" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.item.title) +
                      "\n                "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      width: "80px",
                      display: "flex",
                      "justify-content": "center",
                      gap: "3px",
                      "align-items": "center",
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "material-icons",
                        staticStyle: { color: "#f06a52", "font-size": "small" },
                      },
                      [_vm._v("fingerprint")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "x-small",
                          "font-weight": "bold",
                        },
                      },
                      [_vm._v(_vm._s(_vm.item.customId))]
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.item.endDate
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              content: _vm.timeDifference.message,
                              placement: "top",
                              theme: "light",
                            },
                            expression:
                              "{\n                        content: timeDifference.message,\n                        placement: 'top',\n                        theme: 'light',\n                    }",
                          },
                        ],
                        staticClass: "task-more material-icons",
                        style: { color: _vm.timeDifference.color },
                      },
                      [
                        _vm._v(
                          "\n                    schedule\n                "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "a-popover",
                  {
                    staticClass: "kanban-task-edit-popover",
                    attrs: {
                      overlayClassName: "task-more-options",
                      trigger: "click",
                      placement: "bottomRight",
                    },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.handleInnerClick.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.showPopover,
                      callback: function ($$v) {
                        _vm.showPopover = $$v
                      },
                      expression: "showPopover",
                    },
                  },
                  [
                    _c(
                      "div",
                      { attrs: { slot: "content" }, slot: "content" },
                      [
                        _vm._l(_vm.actions, function (action, index) {
                          return _vm.isShowingAction(action)
                            ? [
                                index !== 0
                                  ? _c("div", { staticClass: "bracket" })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "options-item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.runAction(
                                          action.action,
                                          _vm.item
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "material-icons" },
                                      [_vm._v(_vm._s(action.icon))]
                                    ),
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(action.text) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                              ]
                            : _vm._e()
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "task-more material-icons" }, [
                      _vm._v("more_vert"),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "task-tag" },
              _vm._l(_vm.item.tags || [], function (tag) {
                return _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: { content: tag.name, placement: "top" },
                        expression: "{ content: tag.name, placement: 'top' }",
                      },
                    ],
                    key: tag._id,
                    staticClass: "tag-item",
                    style: _vm.getTagStyle(tag.color),
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(tag.name) +
                        "\n                "
                    ),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "kanban-task-details", on: { click: _vm.view } },
              [
                _c("div", { staticClass: "task-users" }, [
                  _vm.getAssigneesUserId(_vm.item).length > 0
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-right": "10px",
                            display: "flex",
                          },
                        },
                        [
                          _vm._l(
                            _vm.getAssigneesUserId(_vm.item),
                            function (userId, index) {
                              return [
                                index < 2
                                  ? _c("Avatar", {
                                      directives: [
                                        {
                                          name: "tippy",
                                          rawName: "v-tippy",
                                          value: {
                                            followCursor: true,
                                            placement: "bottom-end",
                                          },
                                          expression:
                                            "{\n                                    followCursor: true,\n                                    placement: 'bottom-end',\n                                }",
                                        },
                                      ],
                                      key: userId,
                                      staticStyle: { "margin-right": "-8px" },
                                      attrs: {
                                        size: 25,
                                        src:
                                          _vm.users[userId] &&
                                          _vm.users[userId].gravatar,
                                        username:
                                          _vm.users[userId] &&
                                          _vm.users[userId].name,
                                        content:
                                          _vm.users[userId] &&
                                          _vm.users[userId].email,
                                      },
                                    })
                                  : index === 2
                                  ? _c("div", { staticClass: "more-avatars" }, [
                                      _vm._v(
                                        "\n                                +" +
                                          _vm._s(
                                            _vm.getAssigneesUserId(_vm.item)
                                              .length - 2
                                          ) +
                                          "\n                            "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            }
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        gap: "4px",
                      },
                    },
                    [
                      _vm.item.priority === "low"
                        ? _c("LowIcon")
                        : _vm.item.priority === "lowest"
                        ? _c("LowestIcon")
                        : _vm.item.priority === "medium"
                        ? _c("MediumIcon")
                        : _vm.item.priority === "high"
                        ? _c("HighIcon")
                        : _vm.item.priority === "highest"
                        ? _c("HighestIcon")
                        : _vm._e(),
                      _vm._v(" "),
                      (_vm.item.attachments || []).length > 0
                        ? _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    content: "Bu görevde dosya mevcuttur",
                                    placement: "top",
                                    theme: "light",
                                  },
                                  expression:
                                    "{\n                                content: 'Bu görevde dosya mevcuttur',\n                                placement: 'top',\n                                theme: 'light',\n                            }",
                                },
                              ],
                              staticClass:
                                "material-icons attachment-indicator",
                            },
                            [
                              _vm._v(
                                "\n                            attach_file\n                        "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "kanban-task-alt-items" },
                  [
                    _vm._l(_vm.getUserId(_vm.item), function (userId, index) {
                      return [
                        index < 2
                          ? _c("Avatar", {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    followCursor: true,
                                    placement: "bottom-end",
                                  },
                                  expression:
                                    "{\n                                followCursor: true,\n                                placement: 'bottom-end',\n                            }",
                                },
                              ],
                              key: userId,
                              attrs: {
                                size: 25,
                                src:
                                  _vm.users[userId] &&
                                  _vm.users[userId].gravatar,
                                username:
                                  _vm.users[userId] && _vm.users[userId].name,
                                content:
                                  _vm.users[userId] && _vm.users[userId].email,
                              },
                            })
                          : index === 2
                          ? _c("div", { staticClass: "more-avatars" }, [
                              _vm._v(
                                "+" + _vm._s(_vm.getUserId(_vm.item).length - 2)
                              ),
                            ])
                          : _vm._e(),
                      ]
                    }),
                    _vm._v(" "),
                    (_vm.item.subTasks || []).length > 0
                      ? _c(
                          "div",
                          { staticClass: "kanban-task-alt-items-item" },
                          [
                            _c("div", { staticClass: "material-icons" }, [
                              _vm._v("chat"),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    (_vm.item.subTasks || []).length > 0
                      ? _c(
                          "div",
                          { staticClass: "kanban-task-alt-items-item" },
                          [
                            _c("div", { staticClass: "material-icons" }, [
                              _vm._v("account_tree"),
                            ]),
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.getCompletedParentTaskCount(_vm.item)
                                ) +
                                "/" +
                                _vm._s((_vm.item.subTasks || []).length) +
                                "\n                    "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    (_vm.item.checklist || []).length > 0
                      ? _c(
                          "div",
                          { staticClass: "kanban-task-alt-items-item" },
                          [
                            _c("div", { staticClass: "material-icons" }, [
                              _vm._v("library_add_check"),
                            ]),
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.getCompletedChecklistCount(_vm.item)
                                ) +
                                "/" +
                                _vm._s((_vm.item.checklist || []).length) +
                                "\n                    "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }